module.exports = __webpack_public_path__ + "static/1-03902458ee41b862d68aeb64c77fd98d.jpg";